"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.personaAccountsResultFactory = void 0;
const Factory = require("factory.ts");
const Profiles_1 = require("../Profiles");
const persona_account_factory_1 = require("./persona-account.factory");
exports.personaAccountsResultFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    persona: Profiles_1.personaFactory.build(),
    accounts: persona_account_factory_1.personaAccountFactory.buildList(2),
});
